import { Box } from '@mui/material';
import { SxProps } from '@mui/material/styles';
import LeftArrowIcon from 'assets/images/LeftArrowIcon.png';

const BackToRoadmapButton = ({ sx, onClick }: { sx?: SxProps; onClick: () => void }) => (
  <Box
    sx={{
      marginTop: { xs: '2px', md: '20px' },
      top: '0',
      left: { xs: '8px', md: '24px' },
      position: 'absolute',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '&:hover': {
        cursor: 'pointer',
      },
      ...sx,
    }}
    onClick={onClick}
  >
    <Box
      component="img"
      src={LeftArrowIcon}
      sx={{ height: { xs: '10px', sm: '14px', md: '18px' } }}
    />
    <Box
      sx={{
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: { xs: '10px', sm: '13px', md: '16px' },
        lineHeight: '24px',
        letterSpacing: '0.01em',
        color: '#CA7C62',
        marginLeft: '8px',
        marginBottom: '2px',
        '&:hover': {
          cursor: 'pointer',
        },
      }}
    >
      Back to Roadmap
    </Box>
  </Box>
);

export default BackToRoadmapButton;
